import React from 'react';
import Button from '../../Button';

// Styles
import * as s from './styles';

// Copy
import {multiBrandFooterCopy} from '../../../copy/footer';
import styled from 'styled-components';
import { useLocation } from "@reach/router";

const MultiBrandMobileSpacer = styled.div`
  @media (max-width: 780px) {
    height: 16px;
  }
`;

const MultiBrandFooter = ({pageKey}) => {
  const location = useLocation();
  return (
    <s.MultiBrandStyledFooter>
      <s.MultiBrandFooterWrapper>
        <s.MultiBrandFooterUtils>
          <s.MultiBrandFooterUtilsColumn>
            <s.MultiBrandFooterLogoLink to="/">
            <MultiBrandMobileSpacer />
                <img src={multiBrandFooterCopy.footerLogo.img} alt={multiBrandFooterCopy.footerLogo.alt} />
            </s.MultiBrandFooterLogoLink>
            <MultiBrandMobileSpacer />
            {multiBrandFooterCopy.footerUtilLinks.patientSite.keys.includes(pageKey) &&
              <s.MultiBrandButtonRow>
                <Button
                  variant='tertiary'
                  theme="light"
                  to={ multiBrandFooterCopy.footerUtilLinks.patientSite.href }
                >
                  { multiBrandFooterCopy.footerUtilLinks.patientSite.copy }
                </Button>
              </s.MultiBrandButtonRow>
            }
            <s.TertiaryButton>
            {multiBrandFooterCopy.footerUtilLinks.contactUs.keys.includes(pageKey) &&
              <Button
                variant='tertiary'
                theme="light"
                to={ multiBrandFooterCopy.footerUtilLinks.contactUs.href }
              >
                { multiBrandFooterCopy.footerUtilLinks.contactUs.copy }
              </Button>
            }</s.TertiaryButton>
          </s.MultiBrandFooterUtilsColumn>

          <s.MultiBrandFooterUtilsColumn>
            { multiBrandFooterCopy.footerSiteLinks.col1.filter(footerItem => footerItem.keys.includes(pageKey)).map((footerItem, i) => (
              <s.MultiBrandFooterLink
                key={i}
                to={footerItem.href}
              >
                { footerItem.label }
              </s.MultiBrandFooterLink>
            ))}
          </s.MultiBrandFooterUtilsColumn>

          <s.MultiBrandFooterUtilsColumn>
            { multiBrandFooterCopy.footerSiteLinks.col2.filter(footerItem => footerItem.keys.includes(pageKey)).map((footerItem, i) => (
              <s.MultiBrandFooterLink
                key={i}
                to={footerItem.href}
              >
                { footerItem.label }
              </s.MultiBrandFooterLink>
            ))}
          </s.MultiBrandFooterUtilsColumn>

          <s.MultiBrandFooterUtilsColumn>
            { multiBrandFooterCopy.footerSiteLinks.col3.filter(footerItem => footerItem.keys.includes(pageKey)).map((footerItem, i) => (
              <s.MultiBrandFooterLink
                key={i}
                to={footerItem.href}
              >
                { footerItem.label }
              </s.MultiBrandFooterLink>
            ))}
          </s.MultiBrandFooterUtilsColumn>

        </s.MultiBrandFooterUtils>
        <s.MultiBrandFooterUtilsSublinks>
            <s.MultiBrandSublinkBackground>
              { multiBrandFooterCopy.subLinks.filter(footerItem => footerItem.keys.includes(pageKey)).map((footerItem, i) => (
                <s.MultiBrandFooterSublink
                  key={i}
                  to={footerItem.href}
                  target={footerItem.target ? footerItem.target : '_blank'}
                  className={footerItem.class ? footerItem.class : false}
                >
                  { footerItem.copy }
                  { footerItem.image && <img src={footerItem.image} alt={footerItem.alt ? footerItem.alt : ''} style={{marginLeft: "8px"}} />}
                </s.MultiBrandFooterSublink>
              ))}
            </s.MultiBrandSublinkBackground>
        </s.MultiBrandFooterUtilsSublinks>
      </s.MultiBrandFooterWrapper>

      <s.MultiBrandStyledBottomFooter>
        <s.MultiBrandBottomFooterWrapper>

          <s.MultiBrandBottomFooterLeft>
            <span id="qa-copyright">
            {location.pathname === "/advanced-renal-cell-carcinoma/resources-and-access/"
              ? "This site is intended for health care professionals of the United States, its territories, and Puerto Rico. Copyright © 2026 Merck & Co., Inc., Rahway, NJ, USA and its affiliates. All rights reserved."
              : multiBrandFooterCopy.footerBottom.left.filter(footerItem => footerItem.keys.includes(pageKey)).map((footerItem, i) => (
                footerItem.copy))}
            </span>
            {/* <span id="qa-copyright">
            {multiBrandFooterCopy.footerBottom.left[0].copy}

            </span> */}
            <s.MultiBrandBottomFooterSubcopy id="qa-jobcode">
              {location.pathname === "/advanced-renal-cell-carcinoma/resources-and-access/"
                ? "US-WRC-00506 01/26"
                :multiBrandFooterCopy.footerBottom.left.filter(footerItem => footerItem.keys.includes(pageKey)).map((footerItem, i) => (
                footerItem.subcopy
              ))}
            </s.MultiBrandBottomFooterSubcopy>
          </s.MultiBrandBottomFooterLeft>

          <s.MultiBrandBottomFooterRight>
            <s.MultiBrandAccessibilityLink
              href={multiBrandFooterCopy.footerBottom.accessibility.href}
              target="_blank"
              rel="noreferrer"
            >
              <img className="img-accessibility" src={multiBrandFooterCopy.footerBottom.accessibility.img} alt={multiBrandFooterCopy.footerBottom.accessibility.alt} />
            </s.MultiBrandAccessibilityLink>
            <img className="img-merck" src={multiBrandFooterCopy.footerBottom.merckLogo.img} alt={multiBrandFooterCopy.footerBottom.merckLogo.alt} />
          </s.MultiBrandBottomFooterRight>

        </s.MultiBrandBottomFooterWrapper>
      </s.MultiBrandStyledBottomFooter>

    </s.MultiBrandStyledFooter>

  );
};


export default MultiBrandFooter;
